<template>
  <div v-if="valueIsDefined">
    <case-status-badge
      v-if="value.code"
      :status="value"
      :label-field="params.labelField"
    />
    <span
      v-else
    >
      {{ value }}
    </span>
  </div>
</template>

<script>

import Vue from 'vue'
import CaseStatusBadge from '@/components/common/CommonCaseStatusBadge'

export default Vue.extend({
    name: 'CaseStatusRenderer',
    components: {
        CaseStatusBadge
    },
    computed: {
        valueIsDefined() {
            return this.params.value !== undefined
        },
        value() {
            let value = this.params.value
            if (this.params.isFilterCellRenderer) {
                const valueInStates = this.params.states.find((state) => state.code === this.params.value)
                value = valueInStates || this.params.value
            }
            return value
        }
    }
})

</script>
